import { render } from "./SurveyTakerLocalization.vue?vue&type=template&id=3e413f15"
import script from "./SurveyTakerLocalization.vue?vue&type=script&lang=js"
export * from "./SurveyTakerLocalization.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__